import ApiMode from 'app/models/api_mode';
import Webhooks from 'app/collections/webhooks';

import WebhookListView from 'app/views/webhook_list_view';

import Base from 'app/views/base';
import tmpl from 'templates/webhooks_page';

export default Base.extend({
  compiledTemplate: tmpl,
  className: 'webhooks',

  events: {},

  initialize() {
    this.prodApiMode = new ApiMode({ mode: 'production' });
    this.testApiMode = new ApiMode({ mode: 'test' });

    this.prodCollection = new Webhooks([], { apiMode: this.prodApiMode });
    this.testCollection = new Webhooks([], { apiMode: this.testApiMode });

    this.addSubview('prodWebhookList', '#prod_webhook_list', new WebhookListView({
      collection: this.prodCollection,
      apiMode: this.prodApiMode,
    }));

    this.addSubview('testWebhookList', '#test_webhook_list', new WebhookListView({
      collection: this.testCollection,
      apiMode: this.testApiMode,
    }));

    this.prodCollection.fetch({ reset: true });
    this.testCollection.fetch({ reset: true });
  },
});



// WEBPACK FOOTER //
// ./app/views/webhooks_page.js